import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-static-content-mgt',
  templateUrl: './static-content-mgt.component.html',
  styleUrls: ['./static-content-mgt.component.css']
})
export class StaticContentMgtComponent implements OnInit {
  staticContentData: any = [];
  tabView: any = 'patient';
  constructor(private mainService: MainService, private router: Router) { }

  ngOnInit() {
    this.staticContentList();
  }

  staticContentList() {
    var regex = /(<([^>]+)>)/ig;
    var url;
    if (this.tabView == 'patient') {
      url = ApiUrls.staticContentList

    } else {
      url = ApiUrls.staticContentList + `?appType=THERAPIST`

    }
    // let desc =  this.staticContentForm.value.description.replace(regex, "");
    this.mainService.showSpinner();
    this.mainService.getApi(url, 0).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.staticContentData = []
        // this.staticContentData = res.result ?  res.result : '';
        res.result.forEach((ele: any) => {
          ele['update_des'] = ele.description.replace(regex, "");
          this.staticContentData.push(ele)
        });

        this.mainService.hideSpinner();
      } else {
        this.staticContentData = res.result ? res.result : ''
        this.mainService.hideSpinner();
      }
    })
  }

  viewTab(tab: any) {
    this.tabView = tab;
    this.staticContentList();
  }

  editContent(type: any) {
    const data = {
      'type': type,
      'therapist': 'THERAPIST'
    }
    this.router.navigate(['/edit-static/:id'], { queryParams: { value: JSON.stringify(data) } })
  }

}
